<template>
    <div>
        <page-title>公告管理</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/news/edit">
                            <el-button type="text">发布新公告</el-button>
                        </router-link>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="search.loading" :data="list" style="width: 100%">
                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="add_time" label="时间" width="220">
                    <template slot-scope="scope">
                        <div>添加: {{scope.row.add_time}}</div>
                        <div>更新: {{scope.row.update_time}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <router-link :to="'/dashboard/admin/news/edit?id=' + scope.row.id">编辑</router-link>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="update(scope, {is_delete: 1})">删除</el-button>
                        </template>
                        <template v-else>
                            <span style="color: #909399">已删</span>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="update(scope, {is_delete: 0})">恢复</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="pagination"
                           style="margin: 20px -5px;padding: 0"
                           background
                           layout="prev, pager, next"
                           :total="pagination.totalCount"
                           :page-size="pagination.pageSize"
                           @current-change="page=>{search.page=page;loadData();}"></el-pagination>
        </page-body>
    </div>
</template>

<script>

export default {
    data() {
        return {
            search: {
                page: 1,
                keyword: '',
                loading: false
            },
            list: null,
            pagination: null
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData() {
            this.search.loading = true
            this.$request({
                url: 'admin/news/list',
                params: {
                    page: this.search.page,
                    keyword: this.search.keyword
                }
            }).then(e => {
                this.search.loading = false
                if (e.code === 0) {
                    this.list = e.data.list
                    this.pagination = e.data.pagination
                } else {
                    this.$message.error(e.msg)
                }
            })
        },
        update(scope, data) {
            this.$confirm('确认操作？', '提示').then(() => {
                data['id'] = scope.row.id
                this.$request({
                    url: 'admin/news/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    if (e.code === 0) {
                        this.$message.success('操作成功')
                        this.loadData()
                    } else {
                        this.$message.error(e.msg)
                    }
                }).catch(() => {
                })
            }).catch(() => {
            })
        }
    }
}
</script>

<style scoped>

</style>
